import React from 'react';

interface BackBtnIconProps {
  className?: string;
  color?: string;
}

export const BackBtnIcon: React.FC<BackBtnIconProps> = (props) => {
  const { className, color = '#507FEE' } = props;
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.80474 0.528758C6.06509 0.789108 6.06509 1.21122 5.80474 1.47157L2.27614 5.00016L5.80474 8.52876C6.06509 8.78911 6.06509 9.21122 5.80474 9.47157C5.54439 9.73192 5.12228 9.73192 4.86193 9.47157L0.861929 5.47157C0.601579 5.21122 0.601579 4.78911 0.861929 4.52876L4.86193 0.528758C5.12228 0.268409 5.54439 0.268409 5.80474 0.528758Z" fill={color} />
    </svg>

  );
};
